import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { tableConfigs } from "../../utils/constant";
import { asyncDownloadFile, convertToSlug } from "../../utils/helpers";

const PaginationTable = (props) => {
  const [downloader, setDownloader] = useState(false);

  const {
    typeOfTable,
    tableHeading,
    viewDetailsBtnClick,
    paginatedData,
    viewDetails,
    selectedItems,

    currentPage,
    toggleDropdown,
    isDropdownVisible,
    handleSelectAll,
    handleSelectNone,
    handleSingleSelect,
    setIsDropdownVisible,
  } = props;

  const handleDownload = async (url, nameConvention) => {
    setDownloader(true);
    try {
      await asyncDownloadFile(url, nameConvention);
    } catch (error) {
      console.log(error);
    } finally {
      setDownloader(false);
    }
  };

  function getNestedValue(obj, path, defaultValue = "NA", conditionCallback) {
    if (!obj || !path) return defaultValue;

    const value = path.split(".").reduce((acc, key) => {
      // Handle array syntax like "pan_Cards[0]"
      const arrayMatch = key.match(/(\w+)\[(\d+)]/);
      if (arrayMatch) {
        const [_, prop, index] = arrayMatch;
        return acc && acc[prop] && acc[prop][index] !== undefined ? acc[prop][index] : null;
      }
      return acc && acc[key] !== undefined ? acc[key] : null;
    }, obj);

    if (conditionCallback && typeof conditionCallback === "function") {
      return conditionCallback(value) ? conditionCallback(value) : defaultValue;
    }

    // Handle arrays as a whole
    if (Array.isArray(value)) {
      return value.length ? value.join(", ") : defaultValue; // Combine array elements as a string
    }

    return value !== undefined && value !== null ? value : defaultValue;
  }

  const fetchStatus = (certificates, status) => {
    if (!certificates || certificates?.length === 0) {
      return "--";
    }
    if (status) {
      let status;
      if (certificates.amount_matched === true) {
        status = "AMOUNT_MATCHED";
      } else if (certificates.amount_matched === false) {
        status = "AMOUNT_MISMATCHED";
      } else if (certificates.amount_matched === null) {
        status = "CERTIFICATE_NOT_UPLOADED";
      }
      return status;
    }
    // Approve status
    return certificates?.status;
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const dropdownMenu = document.getElementById("dropdown-menu");
      if (
        dropdownMenu &&
        !dropdownMenu.contains(event.target) &&
        !event.target.closest(".dropdown-button")
      ) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  function getTableCellContent(heading, record, tableType, tableConfigs, index) {
    switch (heading) {
      case "Details":
        return (
          <Link to={`/10bdbe/uploads/${record?._id}/donations`} className="btn-color">
            <button className="btn btn-outline-secondary view-details-btn" type="submit">
              View
            </button>
          </Link>
        );
      case "Email Details":
        return viewDetails === record?._id ? (
          <button
            onClick={() => viewDetailsBtnClick(record._id)}
            className="btn btn-outline-secondary"
          >
            Hide
          </button>
        ) : (
          <button
            onClick={() => viewDetailsBtnClick(record._id)}
            className="btn btn-outline-secondary"
          >
            View
          </button>
        );
      case "S.No":
        // 10 -> items per page
        return (currentPage - 1) * 10 + (index + 1);
      case "FY":
        return "2024-2025";
      case "Certificate Status":
        return fetchStatus(record?.certificates, true);
      case "Approve Status":
        return fetchStatus(record?.certificates);
      case "Donor Name":
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <img
                width="30px"
                src="https://cfstatic.give.do/a5e7242a-5b11-4947-9dd0-4fc18931fe5c.webp"
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <div>{record?.user_name}</div>
            </div>
          </div>
        );
      case "Donor":
        return (
          <div style={{ display: "flex" }}>
            <div>
              <img
                width="30px"
                src="https://cfstatic.give.do/a5e7242a-5b11-4947-9dd0-4fc18931fe5c.webp"
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <div>{record?.user?.name}</div>
              <div>{record?.user?.email}</div>
            </div>
          </div>
        );
      default:
        return getNestedValue(record, tableConfigs[tableType]?.[heading]) || 0;
    }
  }
  return (
    <div className="row table-container">
      <table
        border="1"
        width="100%"
        cellSpacing="0"
        className="no-border-table"
        style={{
          textAlign: "left",
          minWidth: "800px",
          width:"100%"
        }}
      >
        <thead>
          <tr>
            <th style={{ padding: "5px 25px" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <input
                  type="checkbox"
                  style={{ cursor: "pointer" }}
                  checked={
                    paginatedData?.length > 0 &&
                    paginatedData?.every((item) =>
                      (selectedItems.get(currentPage) || [])
                        .map((selectedRecord) => selectedRecord._id)
                        .includes(item._id)
                    )
                  }
                  onChange={(e) => handleSelectAll(e.target.checked)}
                />
                <button
                  // onClick={toggleDropdown}
                  style={{
                    marginTop: "-7px",
                    padding: "5px 10px",
                    cursor: "pointer",
                    backgroundColor: "transparent",
                    border: "none",
                    position: "absolute",
                  }}
                >
                  ▼
                </button>
                {isDropdownVisible && (
                  <ul
                    id="dropdown-menu"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
                      zIndex: 1,
                      listStyleType: "none",
                      margin: 0,
                      padding: "3px 0",
                      width: "100px",
                      borderRadius: "4px",
                    }}
                  >
                    <li
                      style={{ padding: "5px 10px", cursor: "pointer", fontSize: "12px" }}
                      onClick={handleSelectAll}
                    >
                      Select All
                    </li>
                    <li
                      style={{ padding: "5px 10px", cursor: "pointer", fontSize: "12px" }}
                      onClick={handleSelectNone}
                    >
                      Select None
                    </li>
                  </ul>
                )}
              </div>
            </th>
            {tableHeading?.map((table, index) => (
              <th key={index} style={{ textAlign: "left" }}>
                {table}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {paginatedData &&
            paginatedData?.map((record, rowIndex) => (
              <React.Fragment key={record._id}>
                <tr>
                  <td>
                    <input
                      type="checkbox"
                      style={{ cursor: "pointer" }}
                      checked={
                        [...(selectedItems.values() || [])].flat() // Flatten selected items from all pages
                          .some((selectedRecord) => selectedRecord._id === record._id) || false
                      }
                      onChange={() => handleSingleSelect(record)}
                    />
                  </td>
                  {tableHeading.map((heading, index) => (
                    <>
                      <td key={index} style={{ textAlign: "left" }}>
                        {getTableCellContent(heading, record, typeOfTable, tableConfigs, rowIndex)}
                      </td>
                    </>
                  ))}
                </tr>
                {typeOfTable === "EMAIL_TABLE" && viewDetails === record?._id && (
                  <tr>
                    <td colSpan={tableHeading.length + 1}>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "200px 200px 200px",
                           fontWeight: 500,
                          textAlign: "center",
                          marginBottom: "5px",
                          alignItems: "center",
                          justifyContent:"center"
                        }}
                      >
                        <p className="p-tag">NGO Name</p>
                        <p className="p-tag">10BD Amount</p>
                        <p className="p-tag">Certificate Link</p>
                      </div>
                      {record?.certificates_array || record?.certificates 
                        ? (record?.certificates_array || record?.certificates)?.map((item) => (
                            <div
                              key={item?.nonprofit}
                              style={{
                                display: "grid",
                                gridTemplateColumns: "200px 200px 200px",
                                alignItems: "center",
                                textAlign: "center",
                                padding: "5px 0",
                                justifyContent:"center"
                              }}
                            >
                              <p className="p-tag">{item?.nonprofit_name || "NA"}</p>
                              <p className="p-tag">{item?.amount || "NA"}</p>
                              {item?.certificate_uri ? (
                                <p
                                  className={`${downloader ? 'disabled-button' : ''} download-btn`}
                                  onClick={() => handleDownload(item?.certificate_uri, `${convertToSlug(item?.nonprofit_name)}_${record?.user_pan_card}`)}
                                  style={{
                                    color: "#2196f3",
                                    textDecoration: "none",
                                    fontSize: "12px",
                                  }}
                                >
                                  Download Certificate
                                </p>
                              ) : (
                                <p>NA</p>
                              )}
                            </div>
                          ))
                        : "------ NA ------"}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaginationTable;
